import { ToastrService } from "ngx-toastr";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TechnicalDataService } from "../technical-data.service";
import { Subscription } from "rxjs";
import { Group, Vehicule } from "../../../model/data-managemnt";
import { DataManagementService } from "../../data-management/data-management.service";
import { SigninService } from '../../../signin/signin.service';
import { DeviceCarb, DeviceOpt, TechnicalData } from "../../../model/technical-data";
import { Router } from "@angular/router";
import { GlobalService } from "../../../global.config";
import { ChartFullscreenService } from "../../../utils/chart-fullscreen/chart-fullscreen.service";
import { IonModal, ModalController } from "@ionic/angular";
import { MapService } from "../../../utils/leaflet/service/map.service";
import { MapNavigationService } from "../../../utils/map-top-toolbar/map-navigation.service";

import * as Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);
import { IDropdownSettings, MultiSelectComponent } from "ng-multiselect-dropdown";

@Component({
  selector: "app-technical-data",
  templateUrl: "./technical-data.component.html",
  styleUrls: ["./technical-data.component.scss"]
})
export class TechnicalDataComponent implements OnInit {
  @Input() overlayOnly = false;
  @ViewChild('startDateModal') startDateModal: IonModal;
  @ViewChild('endDateModal') endDateModal: IonModal;
  @ViewChild('technicalOptionsDropdown') technicalOptionsDropdown?: MultiSelectComponent;

  optionsDropdownSettings :IDropdownSettings =  {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  optionsItems: any = [];
  selectedOptionItems: { item_text: string; item_id: number }[] = [];

  //Chart vars
  chart: any;
  options: Object;
  serieName: any;

  //Device Options
  deviceopt: DeviceOpt;

  //Device Carburant
  devicecarb: DeviceCarb;

  AllGroups: Subscription;
  vehicule: Vehicule;

  technicaldata: TechnicalData[];

  //MultiSelelct vars
  dropdownList = [];
  selectItems = [];
  dropdownSettings = {};

  isResultLoaded: boolean = true;
  formNotShown = false;

  isGroupLoaded = false;

  lastRefresh: Date;

  fullscreenChartId: string | null = null;

  private startPickerState: { date: string; hour: number; minute: number } | null = null;
  private endPickerState: { date: string; hour: number; minute: number } | null = null;
  private startOpenSnapshot: { date: string; hour: number; minute: number } | null = null;
  private endOpenSnapshot: { date: string; hour: number; minute: number } | null = null;
  private startDismissTimer: ReturnType<typeof setTimeout>;
  private endDismissTimer: ReturnType<typeof setTimeout>;

  selected: any = {
    startDate: new Date(new Date().setHours(0, 0, 0, 0) + (60 * 60 * 1000)).toISOString(),
    endDate: new Date(new Date().setHours(23, 59, 59, 999) + (60 * 60 * 1000)).toISOString(),
  };

  constructor(
    private technicaldataservice: TechnicalDataService,
    public dataManagementService: DataManagementService,
    public toastr: ToastrService,
    public signinService: SigninService,
    private globalService: GlobalService,
    private router: Router,
    private chartFullscreenService: ChartFullscreenService,
    private modalController: ModalController,
    private mapService: MapService,
    private mapNavigationService: MapNavigationService,
  ) {}

  get hasFilteredResults(): boolean {
    return !!this.options;
  }

  closeFilterForm(): void {
    if (this.hasFilteredResults) {
      this.formNotShown = true;
      setTimeout(() => (this.options as any)?.reflow?.(), 200);
      return;
    }
    void this.close();
  }

  ionViewWillEnter() {
    this.dataManagementService.ensureSelectedVehicle();
  }

  ionViewWillLeave() {
    this.exitChartFullscreen();
  }

  isChartFullscreen(chartId: string): boolean {
    return this.fullscreenChartId === chartId;
  }

  async toggleChartFullscreen(chartId: string, chart: any): Promise<void> {
    const exiting = this.fullscreenChartId === chartId;
    if (exiting) {
      this.fullscreenChartId = null;
      await this.chartFullscreenService.exitLandscape();
    } else {
      if (this.fullscreenChartId) {
        this.fullscreenChartId = null;
        await this.chartFullscreenService.exitLandscape();
      }
      this.fullscreenChartId = chartId;
      await this.chartFullscreenService.enterLandscape();
    }
    this.chartFullscreenService.scheduleReflow(chart);
  }

  private async exitChartFullscreen(): Promise<void> {
    if (!this.fullscreenChartId) {
      return;
    }
    this.fullscreenChartId = null;
    await this.chartFullscreenService.exitLandscape();
    this.chartFullscreenService.scheduleReflow(this.options as any);
  }

  dateHandle(event: any, type: string) {
    const value = event.detail.value;
    if (!value) {
      return;
    }

    const state = this.toPickerState(value);

    if (type === 'start') {
      this.selected.startDate = value;
      this.handleDateTimePickerChange('start', state);
    } else {
      this.selected.endDate = value;
      this.handleDateTimePickerChange('end', state);
    }
  }

  onDateModalOpen(type: 'start' | 'end') {
    const value = type === 'start' ? this.selected.startDate : this.selected.endDate;
    const snapshot = this.toPickerState(value);

    if (type === 'start') {
      this.startPickerState = null;
      this.startOpenSnapshot = snapshot;
      clearTimeout(this.startDismissTimer);
    } else {
      this.endPickerState = null;
      this.endOpenSnapshot = snapshot;
      clearTimeout(this.endDismissTimer);
    }
  }

  private toPickerState(value: string) {
    const parsed = new Date(value);
    return {
      date: `${parsed.getFullYear()}-${parsed.getMonth()}-${parsed.getDate()}`,
      hour: parsed.getHours(),
      minute: parsed.getMinutes(),
    };
  }

  private handleDateTimePickerChange(
    type: 'start' | 'end',
    state: { date: string; hour: number; minute: number }
  ) {
    const modal = type === 'start' ? this.startDateModal : this.endDateModal;
    const openSnapshot = type === 'start' ? this.startOpenSnapshot : this.endOpenSnapshot;

    if (type === 'start') {
      this.startPickerState = state;
    } else {
      this.endPickerState = state;
    }

    // Ignore the change fired right after opening (value unchanged from open).
    if (openSnapshot &&
        openSnapshot.date === state.date &&
        openSnapshot.hour === state.hour &&
        openSnapshot.minute === state.minute) {
      return;
    }

    // Close shortly after the user stops choosing (date then time resets the timer).
    this.scheduleDateModalDismiss(type, modal);
  }

  private scheduleDateModalDismiss(type: 'start' | 'end', modal: IonModal) {
    const timer = setTimeout(() => {
      this.resetDatePickerState(type);
      void modal?.dismiss();
    }, 500);

    if (type === 'start') {
      clearTimeout(this.startDismissTimer);
      this.startDismissTimer = timer;
    } else {
      clearTimeout(this.endDismissTimer);
      this.endDismissTimer = timer;
    }
  }

  private resetDatePickerState(type: 'start' | 'end') {
    if (type === 'start') {
      this.startPickerState = null;
      this.startOpenSnapshot = null;
      clearTimeout(this.startDismissTimer);
    } else {
      this.endPickerState = null;
      this.endOpenSnapshot = null;
      clearTimeout(this.endDismissTimer);
    }
  }

  async close() {
    this.mapNavigationService.setToolbarHidden(false);
    if (this.overlayOnly) {
      this.mapService.preventMapDestroy = false;
      try {
        await this.modalController.dismiss();
      } catch {}
      this.mapNavigationService.requestRealtimeMap();
      return;
    }
    try {
      await this.modalController.dismiss();
    } catch {
      this.router.navigate(['/client']);
      return;
    }
    this.mapNavigationService.requestRealtimeMap();
  }

  ngOnInit() {
    this.mapNavigationService.setToolbarHidden(true);
    if (this.overlayOnly) {
      this.formNotShown = false;
      this.mapService.preventMapDestroy = true;
    }

    //init multiselect
    this.dropdownSettings = {
      singleSelection: false,
      text: "Select option",
      selectAllText: "Select Tous",
      unSelectAllText: "UnSelect Tous",
      enableSearchFilter: false,
      classes: "custom-class-multiselect",
      badgeShowLimit: 1
    };

    // Overlay mode: reuse already-loaded groups (don't re-init realtime data).
    if (this.overlayOnly) {
      if (this.dataManagementService.groups?.length > 0) {
        if (!this.dataManagementService.selectedGroup) {
          this.dataManagementService.selectedGroup = this.dataManagementService.groups[0];
        }
        if (!this.dataManagementService.selectedVehicule && this.dataManagementService.selectedGroup?.vehicules?.length > 0) {
          this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
        }
        if (this.dataManagementService.selectedVehicule) {
          this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
        }
      }
      return;
    }

    this.dataManagementService.GroupsLoaded$.subscribe(groups => this.onGroupLoaded(groups));
    this.dataManagementService.init();
    if (this.dataManagementService.selectedVehicule)
      this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
  }


  onGroupLoaded(groups: Group[]) {
    if (this.dataManagementService.groups) {
      this.isGroupLoaded = true;
      if (this.dataManagementService.selectedVehicule)
        this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
    }
  }

  ngOnDestroy() {
    this.mapNavigationService.setToolbarHidden(false);
    this.resetDatePickerState('start');
    this.resetDatePickerState('end');
    if (this.AllGroups) this.AllGroups.unsubscribe();
  }

  deleteItemById(itemId) {
    this.optionsItems = this.optionsItems.filter(item => item.item_id !== itemId);
  }
  //Get Device Options and fill the dropdownList
  getDeviceOpt(deviceid: number) {
    this.selectedOptionItems = [];
    this.dropdownList = [];
    this.optionsItems = [
      { "item_id": 0, "item_text": "RPM" },
      { "item_id": 1, "item_text": "Vitesse" },
      // { "item_id": 2, "item_text": "Carburant Total" },
      { "item_id": 3, "item_text": "Carburant" },
      // { "item_id": 4, "item_text": "Vitesse" },
      { "item_id": 5, "item_text": "Temp Moteur" },
      { "item_id": 6, "item_text": "Consomation Inst" },
    ];
    this.isResultLoaded = false;
    this.technicaldataservice.getDeviceOpt(deviceid).subscribe(response => {
      this.deviceopt = response;
      // this.dropdownList.push({ id: 1, option: "ignition,speed", itemName: "Vitesse" });
      if (
        this.deviceopt.useFuel === 0 &&
        this.deviceopt.useFms === 0 &&
        this.deviceopt.useJ1708 === 0
      ) {
        this.deleteItemById(3)
        // this.dropdownList.push({
        //   id: 3,
        //   option: "ignition,fuel",
        //   itemName: "Carburant"
        // });
      }
      if (this.deviceopt.useFms === 0 && this.deviceopt.useJ1708 === 0) {
        // this.dropdownList.push({ id: 4, option: "rpm", itemName: "RPM" });
        // this.dropdownList.push({
        //   id: 0,
        //   option: "ignition,rpm",
        //   itemName: "RPM"
        // });
        this.deleteItemById(0);
        // this.dropdownList.push({
        //   id: 5,
        //   option: "ignition,temp_engine",
        //   itemName: "Temp Moteur"
        // });
        this.deleteItemById(5);
        // this.dropdownList.push({
        //   id: 6,
        //   option: "ignition,fuel_rate",
        //   itemName: "Consomation Inst"
        // });
        this.deleteItemById(6);
      }
      this.isResultLoaded = true;
    });
  }

  onItemSelect(item: any) {
  }

  onTechnicalOptionSelect(dropdown: MultiSelectComponent): void {
    setTimeout(() => this.closeTechnicalOptionsDropdownIfAllSelected(dropdown), 0);
  }

  onTechnicalOptionSelectAll(dropdown: MultiSelectComponent): void {
    setTimeout(() => this.closeTechnicalOptionsDropdown(dropdown), 0);
  }

  onTechnicalOptionsModelChange(items: { item_id: number }[]): void {
    const available = this.optionsItems || [];
    if (available.length > 0 && items?.length >= available.length) {
      this.closeTechnicalOptionsDropdown();
    }
  }

  private closeTechnicalOptionsDropdownIfAllSelected(dropdown?: MultiSelectComponent): void {
    const target = dropdown ?? this.technicalOptionsDropdown;
    if (target?.isAllItemsSelected()) {
      this.closeTechnicalOptionsDropdown(target);
    }
  }

  private closeTechnicalOptionsDropdown(dropdown?: MultiSelectComponent): void {
    const target = dropdown ?? this.technicalOptionsDropdown;
    target?.closeDropdown();
    this.optionsDropdownSettings = {
      ...this.optionsDropdownSettings,
      defaultOpen: false,
    };
  }

  displayChart() {
    this.isResultLoaded = false;
    this.selectItems = [];
    this.selectedOptionItems.forEach(item => {
      const itemMapping = {
        0: {"id": 0, "option": "ignition,rpm", "itemName": "RPM"},
        1: { "id": 1, "option": "ignition,speed", "itemName": "Vitesse" },
        // 2: { "id": 2, "option": "tfu", "itemName": "Carburant Total" },
        3: {"id": 3, "option": "ignition,fuel", "itemName": "Carburant"},
        // 4: { "id": 4, "option": "speed", "itemName": "Vitesse" },
        5: {"id": 5, "option": "ignition,temp_engine", "itemName": "Temp Moteur"},
        6: {"id": 6, "option": "ignition,fuel_rate", "itemName": "Consomation Inst"}
      };

      if (itemMapping[item.item_id]) {
        this.selectItems.push(itemMapping[item.item_id]);
      }
    });
    this.lastRefresh = new Date();
    //Get Selected Options
    let devopt = [];
    if (this.selectItems.length > 0) {
      this.selectItems.forEach(itm => {
        devopt.push(itm.option);
      });
    }

    // Options vars
    let speed = [];
    let fuel = [];
    let temp = [];
    let ignition = [];
    let rpm = [];
    let temp_engine = [];
    let fuel_rate = [];
    let ok: boolean = false;

    //Select data Device carburant
    this.technicaldataservice
      .getDeviceCarb(this.dataManagementService.selectedVehicule.device.idDevice)
      .subscribe(res => {
        this.devicecarb = res;
      });

    //Get Fuel Data and fill all options
    this.technicaldataservice
      .getFuelDetail(
        this.dataManagementService.selectedVehicule.device.idDevice,
        {
          startDate: this.selected.startDate,
          endDate: this.selected.endDate
        },
        devopt
      )
      .subscribe(res => {
        this.technicaldata = res;
        if (this.technicaldata.length == 0) {
          this.toastr.warning("Pas de données à afficher");
        }
        this.technicaldata.forEach(stat => {
          if (stat.speed != undefined) {
            speed.push({ x: stat.date, y: stat.speed });
          }
          if (stat.fuel != undefined) {
            if (this.devicecarb.max - this.devicecarb.min > 0) {
              if (
                stat.fuel >= this.devicecarb.min &&
                stat.fuel <= this.devicecarb.max
              ) {
                fuel.push({
                  x: stat.date,
                  y:
                    ((stat.fuel - this.devicecarb.min) /
                      (this.devicecarb.max - this.devicecarb.min)) *
                    this.devicecarb.volume
                });
              }
            } else {
              if (
                stat.fuel >= this.devicecarb.max &&
                stat.fuel <= this.devicecarb.min
              ) {
                fuel.push({
                  x: stat.date,
                  y:
                    ((stat.fuel - this.devicecarb.min) /
                      (this.devicecarb.max - this.devicecarb.min)) *
                    this.devicecarb.volume
                });
              }
            }
          }
          if (stat.ignition != undefined) {
            ignition.push({ x: stat.date, y: stat.ignition ? 1 : 0 });
            ok = true;
          }
          if (stat.rpm != undefined && ok == true) {
            rpm.push({ x: stat.date, y: stat.rpm });
          }
          if (stat.temp_engine != undefined && ok == true) {
            temp_engine.push({ x: stat.date, y: stat.temp_engine });
          }
          if (stat.fuel_rate != undefined && ok == true) {
            fuel_rate.push({ x: stat.date, y: stat.fuel_rate });
          }
        });

        //Charts vars
        let serie = [];
        let yaxis = [];

        for (let i = 1; i < ignition.length; i++) {
          if (
            ignition[i].y > ignition[i - 1].y ||
            ignition[i].y < ignition[i - 1].y
          ) {
            ignition[i].x = ignition[i - 1].x;
          }
        }

        //Fill all series and yxais
        if (this.ChartSeries(ignition) == true) {
          yaxis.push({
            title: {
              text: "Ignition",
              style: {
                color: "rgb(255, 127, 0)"
              }
            },
            labels: {
              style: {
                color: "rgb(255, 127, 0)"
              }
            },
            min: 0,
            max: 1,
            alignTicks: false,
            endOnTick: false,
            tickInterval: 1
          });
          serie.push({
            name: "Ignition",
            type: "area",
            color: "rgb(255, 127, 0)",
            data: ignition,
            yAxis: this.PositionYaxis(yaxis, "Ignition")
          });
        }
        if (this.ChartSeries(speed) == true) {
          yaxis.push({
            title: {
              text: "vitesse",
              style: {
                color: "rgb(44, 161, 33)"
              }
            },
            labels: {
              format: "{value} " + "Km/h",
              style: {
                color: "rgb(44, 161, 33)"
              }
            },
            min: 0
          });
          serie.push({
            name: "Vitesse",
            data: speed,
            color: "rgb(44, 161, 33)",
            yAxis: this.PositionYaxis(yaxis, "vitesse"),
            tooltip: {
              valueSuffix: "KM/H",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(fuel) == true) {
          yaxis.push({
            title: {
              text: "carburant",
              style: {
                color: "rgb(23, 119, 182)"
              }
            },
            labels: {
              format: "{value} " + "L",
              style: {
                color: "rgb(23, 119, 182)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "Carburant",
            data: fuel,
            color: "rgb(23, 119, 182)",
            yAxis: this.PositionYaxis(yaxis, "carburant"),
            tooltip: {
              valueSuffix: "L",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(temp) == true) {
          yaxis.push({
            title: {
              text: "temperature",
              style: {
                color: "rgb(107, 57, 156)"
              }
            },
            labels: {
              format: "{value} " + "°C",
              style: {
                color: "rgb(107, 57, 156)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "Temperature",
            data: temp,
            color: "rgb(107, 57, 156)",
            yAxis: this.PositionYaxis(yaxis, "temperature"),
            tooltip: {
              valueSuffix: "°C",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(rpm) == true) {
          yaxis.push({
            title: {
              text: "RPM",
              style: {
                color: "rgb(230, 20, 9)"
              }
            },
            labels: {
              format: "{value} " + "Tr/Min",
              style: {
                color: "rgb(230, 20, 9)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "rpm",
            data: rpm,
            color: "rgb(230, 20, 9)",
            yAxis: this.PositionYaxis(yaxis, "RPM"),
            tooltip: {
              valueSuffix: "Tr/Min",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(temp_engine) == true) {
          yaxis.push({
            title: {
              text: "temp Moteur",
              style: {
                color: "rgb(179, 89, 31)"
              }
            },
            labels: {
              format: "{value} " + "°C",
              style: {
                color: "rgb(179, 89, 31)"
              }
            },
            min: 0,
            opposite: yaxis.length !== 0
          });
          serie.push({
            name: "Temp Moteur",
            data: temp_engine,
            color: "rgb(179, 89, 31)",
            yAxis: this.PositionYaxis(yaxis, "temp Moteur"),
            tooltip: {
              valueSuffix: "°C",
              valueDecimals: 2
            }
          });
        }
        if (this.ChartSeries(fuel_rate) == true) {
          yaxis.push({
            title: {
              text: "Consomation Inst",
              style: {
                color: "rgb(75,93,157)"
              }
            },
            labels: {
              format: "{value} " + "L",
              style: {
                color: "rgb(75,93,157)"
              }
            },
            min: 0
          });
          serie.push({
            name: "Consomation Inst",
            data: fuel_rate,
            color: "rgb(75,93,157)",
            yAxis: this.PositionYaxis(yaxis, "Consomation Inst"),
            tooltip: {
              valueSuffix: "°C",
              valueDecimals: 2
            }
          });
        }

        //Create a new HighChart
        this.options = new Highcharts.Chart({
          time: {
            timezoneOffset: this.globalService.time_difference
          },
          title: { text: "Véhicule: " + this.dataManagementService.selectedVehicule.matricule },
          chart: {
            type: "spline",
            renderTo: "container",
            height: 420,
            zoomType: "x"
          } as any,

          xAxis: [
            {
              type: "datetime",
              tickInterval: 3600 * 1000,
              labels: {
                formatter: function () {
                  return Highcharts.dateFormat("%d/%m/%Y %H:%M", Number(this.value));
                }
              },
              crosshair: true
            }
          ],

          yAxis: yaxis,

          plotOptions: {
            series: {
              turboThreshold: 100000
            }
          },

          series: serie
        });
        this.isResultLoaded = true;
      });

  }

  //Return the position of Yaxis
  PositionYaxis(data: any, option: string): number {
    for (let i = 0; i < data.length; i++) {
      if (data[i].title.text === option) {
        return i;
      }
    }
    return -1;
  }

  //check if the series is empty or not
  ChartSeries(data: any = []) {
    let ok: boolean;
    data.forEach(dt => {
      ok = dt.y == undefined ? false : true;
    });
    return ok;
  }

  saveInstance(chartInstance) {
    this.chart = chartInstance;
  }

  onSeriesMouseOver(e) {
    this.serieName = e.context.name;
  }

  chooseGroup(group) {
    this.dataManagementService.selectedGroup = group;
    if (this.dataManagementService.selectedGroup.vehicules.length > 0 && this.dataManagementService.selectedGroup) {
      this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
      this.selectItems = [];
    }
  }

  chooseVehicule(vehicule) {
    this.dataManagementService.selectedVehicule = vehicule;
    this.getDeviceOpt(this.dataManagementService.selectedVehicule.device.idDevice);
    this.selectItems = [];
  }
}
